
























































































































































































































































































































































































































import {
  defineComponent,
  onMounted,
  ref,
  Ref,
  computed,
  watch,
} from "@vue/composition-api";
import {
  SubscriptionDetailsDto,
  SubscriptionApi,
  ArticleRegistrationApi,
  ProjectDto,
} from "@/api";
import { useMachine } from "@xstate/vue";
import { toLocalDateStringShort } from "@/util/date";
import { formatCurrency } from "@/util/currency";
import { downloadDocument } from "@/util/download";
import router from "@/router";
import Store from "@/store";
import subscriptionDetailListMachine from "./SubscriptionDetailListMachine";

export default defineComponent({
  name: "SubscriptionsDetail",
  components: {},
  setup(props, vm) {
    const api = new SubscriptionApi();
    const articleRegistrationApi = new ArticleRegistrationApi();
    const { state, send, service } = useMachine(subscriptionDetailListMachine);
    const subscription: Ref<SubscriptionDetailsDto | null> = ref(null);
    const datePickerMenu = ref(false);
    const endDatePickerMenu = ref(false);
    const employmentDate = ref<string | null>("");
    const endDate = ref<string | null>("");
    let possibleEndDates: string[] = [];
    const loading = ref(true);
    const endEmploymentLoading = ref(false);

    const selectedProject = computed<ProjectDto | null>(
      () => Store.getters["User/getSelectedProject"]
    );

    const ignoreEndDateForEmployer = computed<boolean>(
      () => selectedProject?.value?.ignoreEndDateForEmployer ?? false
    );

    async function getSubscriptionDetail(): Promise<SubscriptionDetailsDto> {
      const id = Number(vm.root.$route.params.id);
      return api
        .subscriptionGetSubscriptionDetails(id)
        .then((response) => {
          service.send("RESOLVE");
          return response.data;
        })
        .catch(() => {
          service.send("REJECT");
          return {};
        });
    }

    // TODO Move to approve detail view
    async function generateAao() {
      try {
        if (subscription.value?.articleRegistrationId) {
          await articleRegistrationApi.articleRegistrationApproveArticleRegistration(
            {
              articleRegistrationId: subscription.value?.articleRegistrationId,
            }
          );
        }
      } catch (err) {
        throw new Error("Could not export registrations");
      }
    }

    async function downloadAao() {
      if (subscription.value?.articleRegistrationId) {
        const {
          data,
          headers,
        } = await articleRegistrationApi.articleRegistrationDownloadAaoFile(
          subscription.value?.articleRegistrationId,
          {
            responseType: "arraybuffer",
          }
        );

        downloadDocument(data, headers);
      }

      return {
        downloadAao,
      };
    }

    async function getAvailableEndDates() {
      return api
        .subscriptionGetPossibleSubscriptionEndDates({
          subscriptionId: subscription.value?.subscriptionId || 0,
        })
        .then((response) => {
          return response.data.map((date) => {
            return date.substring(0, 10);
          });
        });
    }

    const formatDate = (d: string | null) => {
      if (!d) {
        return "";
      }
      // Format in current locale.
      return toLocalDateStringShort(d);
    };

    const endEmployment = computed({
      get(): string {
        return formatDate(employmentDate.value || "");
      },
      set(value: string | null) {
        employmentDate.value = value;
      },
    });

    const parsedEndDate = computed({
      get(): string {
        return formatDate(endDate.value || "");
      },
      set(value: string | null) {
        endDate.value = value;
      },
    });

    function availableEndDates(date: string) {
      return possibleEndDates.indexOf(date) > -1;
    }

    function onEndEmployment() {
      endEmploymentLoading.value = true;
      api
        .subscriptionCancelSubscriptionOutOfServiceEmployee({
          subscriptionId: subscription.value?.subscriptionId || 0,
          employementEndDate: employmentDate.value || "",
          desiredSubscriptionEndDate: endDate.value || "",
        })
        .then(() => {
          endEmploymentLoading.value = false;
          router.push({ name: "subscriptions-ended" });
        })
        .catch(() => {
          endEmploymentLoading.value = false;
        });
    }

    onMounted(async () => {
      loading.value = true;
      subscription.value = await getSubscriptionDetail();

      possibleEndDates = await getAvailableEndDates();
      // Set end date to first possibility.
      if (possibleEndDates[0]) {
        // eslint-disable-next-line prefer-destructuring
        parsedEndDate.value = possibleEndDates[0];
      }
      loading.value = false;
    });

    watch(selectedProject, () => {
      if (loading.value) return;
      vm.root.$router.push({ name: "dashboard" });
    });

    watch(employmentDate, () => {
      if (!employmentDate.value) return;
      // Set end date to first possible date after employment date.
      const firstEndDate = possibleEndDates.find(
        (e) => employmentDate.value && e >= employmentDate.value
      );
      endDate.value = firstEndDate ?? null;
    });

    return {
      availableEndDates,
      toLocalDateStringShort,
      send,
      service,
      state,
      subscription,
      endEmployment,
      employmentDate,
      datePickerMenu,
      endDatePickerMenu,
      parsedEndDate,
      endDate,
      formatCurrency,
      downloadAao,
      downloadDocument,
      generateAao,
      onEndEmployment,
      endEmploymentLoading,
      loading,
      ignoreEndDateForEmployer,
    };
  },
});
